import $ from 'jquery';

export default () => {
  $('#block-views-block-featured-content-block-1 .view-content')
    .addClass('owl-carousel owl-theme')
    .owlCarousel({
      loop: true,
      margin: 15,
      responsive: {
        '0': {
          items: 1,
          center: true,
          autoWidth: true,
          slideBy: 1,
        },
        '768': {
          items: 3,
          center: false,
          autoWidth: false,
          slideBy: 3,
        },
        '1280': {
          items: 4,
          slideBy: 4,
        }
      }
    });
}
